export default "__VITE_ASSET__BqtaHNsA__"